import { LegalDoc } from "@/components/LegalDoc";

export default function Terminos() {
  return <LegalDoc endpoint="/public/terminos" slug="terminos" footerLabel="Términos y Condiciones de Uso"
    related={{ to: "/privacidad", label: "Ver Política de Privacidad" }} />;
}
